import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueDragDrop from 'vue-drag-drop';
import ProjectComponents from './components';
import BreakingHitsESB from './components/bh-esb';
import DateRangePicker from "@gravitano/vue-date-range-picker";

Vue.config.productionTip = false;

Vue.use(DateRangePicker);
Vue.use(ProjectComponents);
Vue.use(VueDragDrop);
Vue.use(BreakingHitsESB);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
